import { useMutation } from "@tanstack/react-query";
import { validateMailchimpCredentials } from '../../api/bIntegrationsApi';

export const useValidateMailchimp = () => {
  return useMutation({
    mutationKey: ['validate-mailchimp'],
    mutationFn: (data) => validateMailchimpCredentials(data),
    onError: (error) => {
      console.error('Validation error details:', error.response || error);
    },
  });
};